import { Loading } from 'element-ui';
var options = {
  lock: true,
  text: '数据提交中...',
  spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.7)'
};
export function openLoading() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '数据提交中...';
  options.text = text;
  Loading.service(options);
}
export function closeLoading() {
  var loadingInstance = Loading.service(options);
  this.$nextTick(function () {
    // 以服务的方式调用的 Loading 需要异步关闭
    loadingInstance.close();
  });
}